module.exports = __webpack_public_path__ + "static/img/fd_logo.a4e73607.png";